import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const InvestigationFilterToolbar = ({ filters, onFilterChange, onClearFilters, resultsCount }) => {
  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'plant-1', label: 'Plant 1 - Main Facility' },
    { value: 'plant-2', label: 'Plant 2 - North Wing' },
    { value: 'plant-3', label: 'Plant 3 - South Wing' },
    { value: 'warehouse-1', label: 'Warehouse 1' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'initiated', label: 'Initiated' },
    { value: 'ongoing', label: 'Ongoing' },
    { value: 'completed', label: 'Completed' },
    { value: 'overdue', label: 'Overdue' }
  ];

  const investigatorOptions = [
    { value: 'all', label: 'All Investigators' },
    { value: 'Dr. Sarah Johnson', label: 'Dr. Sarah Johnson' },
    { value: 'Michael Chen', label: 'Michael Chen' },
    { value: 'Emily Rodriguez', label: 'Emily Rodriguez' },
    { value: 'Robert Thompson', label: 'Robert Thompson' },
    { value: 'Lisa Anderson', label: 'Lisa Anderson' }
  ];

  const priorityOptions = [
    { value: 'all', label: 'All Priorities' },
    { value: 'critical', label: 'Critical' },
    { value: 'major', label: 'Major' },
    { value: 'moderate', label: 'Moderate' },
    { value: 'minor', label: 'Minor' }
  ];

  const hasActiveFilters = 
    filters?.location !== 'all' || 
    filters?.status !== 'all' || 
    filters?.investigator !== 'all' ||
    filters?.priority !== 'all' ||
    filters?.startDate ||
    filters?.endDate;

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h2 className="text-lg font-semibold text-foreground">Filters</h2>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClearFilters}
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Location"
          options={locationOptions}
          value={filters?.location}
          onChange={(value) => onFilterChange('location', value)}
        />

        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="Investigator"
          options={investigatorOptions}
          value={filters?.investigator}
          onChange={(value) => onFilterChange('investigator', value)}
        />

        <Select
          label="Priority"
          options={priorityOptions}
          value={filters?.priority}
          onChange={(value) => onFilterChange('priority', value)}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Input
          label="Search"
          type="search"
          placeholder="Incident ID or title..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Input
          label="Incident Date From"
          type="date"
          value={filters?.startDate}
          onChange={(e) => onFilterChange('startDate', e?.target?.value)}
        />

        <Input
          label="Incident Date To"
          type="date"
          value={filters?.endDate}
          onChange={(e) => onFilterChange('endDate', e?.target?.value)}
        />
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-sm text-muted-foreground">
          Showing <span className="font-semibold text-foreground">{resultsCount}</span> investigation{resultsCount !== 1 ? 's' : ''}
        </p>
      </div>
    </div>
  );
};

export default InvestigationFilterToolbar;